import { ApiService } from '../../common'

export class AppCommentsApi extends ApiService {}
